import React, { useState, useEffect } from "react";
import styles from "../src/styles/imagecycler.module.css";

export default function ImageCycler({ imgsArr, cityPercentages, cityName }) {
    const [currImgIndx, setCurrImgIndx] = useState(0)
    const [source, setSource] = useState()

    useEffect(() => {
        setCurrImgIndx(0);
    }, [imgsArr]);

    useEffect(() => {
        if (imgsArr.length !== 0) {
            setSource(`https://citiesdetect.s3.us-east-1.amazonaws.com/${imgsArr[currImgIndx]}`)
        }
    }, [currImgIndx, imgsArr]);

    const moveLeft = () => {
        if (currImgIndx <= 0) {
            setCurrImgIndx(imgsArr.length - 1)
        } else {
            setCurrImgIndx(currImgIndx - 1);
        }
    }

    const moveRight = () => {
        if (currImgIndx >= (imgsArr.length - 1)) {
            setCurrImgIndx(0)
        } else {
            setCurrImgIndx(currImgIndx + 1);
        }
    }

    if (imgsArr.length === 0) {
        return (
            <div className={styles.stage}>
                <div className={styles.placeholder}>
                    <span className={styles.placeholderdot} />
                    <p className={styles.placeholdertext}>Gathering postcards</p>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.stage}>
            <div className={styles.viewer}>
                <button className={styles.arrow} onClick={moveLeft} aria-label="Previous photo">&larr;</button>

                <figure className={styles.plate}>
                    <img className={styles.plateimg} src={source} alt={`Street in ${cityName || "this city"}`} />
                    <figcaption className={styles.platecap}>
                        {cityName || "A kindred city"}
                        <span className={styles.platecount}>{currImgIndx + 1} / {imgsArr.length}</span>
                    </figcaption>
                </figure>

                <button className={styles.arrow} onClick={moveRight} aria-label="Next photo">&rarr;</button>
            </div>

            {cityPercentages !== "" && (
                <p className={styles.match}>Architectural match &middot; {cityPercentages}</p>
            )}
        </div>
    )
}
